module.exports = __webpack_public_path__ + "static/media/tøyse.59cc1b79.m4a";